import { Platform } from 'react-native'

export const isNative = () => Platform.OS === 'ios' || Platform.OS === 'android'
